import { render, staticRenderFns } from "./giftTicket.vue?vue&type=template&id=5c0fa789&scoped=true&"
import script from "./giftTicket.vue?vue&type=script&lang=js&"
export * from "./giftTicket.vue?vue&type=script&lang=js&"
import style0 from "./giftTicket.vue?vue&type=style&index=0&id=5c0fa789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fa789",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
